// eslint-disable-next-line
export const trausureFileTypes = {
  plain: 0,
  commercial_at: 1,
  ft: 2,
};
